export const FORECAST_ADVISORIES_ROUTE = 'getCWActiveAlerts';

export const FORECAST_ADVISORIES_REFRESH_INTERVAL_MINUTES = 3;

export const FORECAST_ADVISORIES_QUERY_OPTIONS = Object.freeze({
  pollingInterval: FORECAST_ADVISORIES_REFRESH_INTERVAL_MINUTES * 60_000,
  refetchOnMountOrArgChange: true,
});

export const FORECAST_ADVISORY_MODES = Object.freeze({
  all: 'all',
  local: 'local',
});

export const DEFAULT_FORECAST_ADVISORY_DISTANCE_MILES = 100;
export const MAXIMUM_FORECAST_ADVISORY_DISTANCE_MILES = 1_000;
